import { api } from "@/builders/axios";
import { activate_or_deactivate } from "./activate-or-deactivate";

type User = {
  role_ids: Array<number>;
  first_name: string;
  last_name: string;
  other_names: string;
  phone_number: string;
  email: string;
};

const get = function (username: string) {
  return api.get<User>(`users/${username}`);
};

const put = function (username: string, data: User) {
  return api.put(`/users/${username}`, data);
};

const patch = function (username: string, data: Partial<User>) {
  return api.patch(`/users/${username}`, data);
};

const del = function (username: string) {
  return api.delete(`/users/${username}`);
};

export const username = {
  get,
  put,
  patch,
  del,
  activate_or_deactivate,
};
